document.addEventListener('click', function(e) {
  if (!e.target.closest('.collapse-open-all')) return

  document.querySelectorAll('.collapse').forEach(
    (col) => { col.classList.toggle('show') }
  )
})
